// extracted by mini-css-extract-plugin
export var label = "ArticleMeta-module--label--opwOO";
export var row = "ArticleMeta-module--row--tj0Sj";